import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import "./Offers.css";
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';


function Offers() {
	return (
		<div className="offers">
			<NavBar page="offers"/>
				<div className="offers__homePage">
					<div className="offers__homePageOfferContainer">
						<h1 className="offers__homePageOfferContainerTxt"> Spend over $100 and win a Free handmade Teddy bear </h1>
						<Link to="/Menu" className="go__to__menu__button" style={{textDecoration: "none"}}>
							<Button variant="contained" color="primary"> Go to Menu </Button>
						</Link>
						<div className="offers__homePageOfferBackground"> </div>
					</div>
				</div>
			<Footer />
		</div>
	)
}



export default Offers;